import React from 'react'

import { Modal, Button, Row, Col, Typography } from 'antd'

const { Text } = Typography

const DIGITS = [1, 2, 3, 4, 5, 6, 7, 8, 9]

// 🔴 THE CELL MENU (George, 22 September 2026): "when i click on a black cell, open a menu
// of 9 numbers i can put there, with a x out so i can close the window. if i click a
// number, put it there, then evaluate if its wrong or right. if its wrong, the mune comes
// up again, this time for an option to clear the cell."
//
// So: the nine digits in a 3x3 block, the modal's own x in the corner to close it, and —
// only once the game has REJECTED a digit — the digit itself, WHY it was refused, and a
// "Clear this cell" button. `mistake` is `{ value, reason }` for the rejected digit sitting in
// this cell, or undefined when there is none, which is why the Clear button cannot appear on a
// first, empty click.
//
// 🔴 THE REASON IS THE POINT (added 22 September 2026). George asked "how can 7 not go there?
// its the only available space according to sudoku rules" — and the site refused the move
// without saying that a 7 was already in that row, column or box, which the menu was covering
// up. The engine's own `findClash` / `describeClash` produce this line, so it cannot drift from
// the rule that actually refused the move.
const CellMenu = ({ cell, mistake, onPick, onClear, onClose }) => {
  return (
    <Modal
      open={Boolean(cell)}
      onCancel={onClose}
      footer={null}
      width={300}
      centered
      title={cell ? `Row ${cell.row + 1} · Column ${cell.column + 1}` : ''}
    >
      <Row gutter={[8, 8]}>
        {
          DIGITS.map(n => (
            <Col span={8} key={`pick_${n}`}>
              <Button block size='large' onClick={() => onPick(n)}>{n}</Button>
            </Col>
          ))
        }
      </Row>

      {
        mistake === undefined
          ? null
          : (
            <div style={{ marginTop: 16, textAlign: 'center' }}>
              <Text style={{ color: '#f87171' }}>{mistake.value} does not go there.</Text>
              {
                mistake.reason
                  ? <div style={{ marginTop: 4 }}><Text style={{ color: '#f87171' }}>{mistake.reason}</Text></div>
                  : null
              }
              <Button danger block size='large' style={{ marginTop: 10 }} onClick={onClear}>
                Clear this cell
              </Button>
            </div>
            )
      }
    </Modal>
  )
}

export default CellMenu
